export default "__VITE_ASSET__ClOw85IJ__"